import classNames from "classnames"
import React from "react"

import RatingStars from "../../../elements/V2/RatingStars"

import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import {
  getBackgroundColorClass,
  getBorderColorClass,
  getShadowColorClass,
} from "@utils/V2/color"

export type Reviewer = {
  icon?: string
  name: string
  businessName: string
}

export type TestimonialProps = {
  rating: number
  reviewText: string
  reviewer: Reviewer
}

type Props = {
  textColor: Color
  cardColor?: Color
  cardBorderColor?: Color
  cardDropShadow?: boolean
  hideStars?: boolean
} & TestimonialProps

export default function TestimonialCard({
  rating,
  reviewText,
  reviewer,
  textColor,
  cardColor,
  cardBorderColor,
  cardDropShadow = false,
  hideStars,
}: Props) {
  return (
    <div
      className={classNames(
        "flex flex-col gap-16 rounded-20 border border-opacity-25 px-20 py-[30px] sm:px-32 sm:py-24 lg:gap-20 lg:py-32",
        getBackgroundColorClass(cardColor ?? Color.Coal),
        getBorderColorClass(cardBorderColor || cardColor || Color.Coal),
        cardDropShadow && `shadow-md ${getShadowColorClass(Color.Black)}`
      )}
    >
      {!hideStars && <RatingStars rating={rating} ratingColor={textColor} />}

      <Typography
        text={reviewText}
        color={textColor}
        font="grotesk"
        weight="book"
        size="body-md"
        className="flex-1"
      />

      <div className="flex items-center gap-10 lg:gap-20">
        {reviewer.icon && (
          <GatsbyStoryblokImage
            image={reviewer.icon}
            alt={`Testimonial photo of ${reviewer.name}`}
            width={44}
            height={44}
            aspectRatio="1:1"
          />
        )}

        <div>
          <Typography
            size="body-md"
            font="grotesk"
            weight="medium"
            color={textColor}
            text={reviewer.name}
          />

          <Typography
            size="body-md"
            font="grotesk"
            weight="book"
            color={textColor}
            text={reviewer.businessName}
            className="opacity-50"
          />
        </div>
      </div>
    </div>
  )
}
